import { RefSerializer } from "@tblabs/truffle";
import { Expanse } from "../../Models/Expanse";
import { Converter } from "@tblabs/storage";
import { RawExpanse } from "../../Models/RawExpanse";


export class ExpansesConverter extends Converter<RawExpanse[], Expanse[]>
{
    public ConvertToRaw(expanses: Expanse[]): RawExpanse[]
    {
        return RefSerializer.Flatenize(expanses);
    }

    public ConvertFromRaw(raw: RawExpanse[]): Expanse[]
    {
        return raw.map(x => new Expanse(x));
    }
}
